// @mui material components
import Autocomplete from "@mui/material/Autocomplete";
import { Box, LinearProgress, TextField } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Tooltip from "@mui/material/Tooltip";

// NewUser page components
import FormField from "components/FormField";
import { useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "config";
import { useAuthContext } from "context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";

const payload = {
  private_description: "",
  situation_document: "",
  reason_reprovation: "",
  account_number: "",
  pa_id: "",
};

export default function CooperatedDescriptionsSeventh() {
  const [cooperated, setCooperated] = useState(payload);
  const [pas, setPas] = useState([]);
  const [pa, setPa] = useState("");
  const [inputPa, setInputPa] = useState("");
  const [situationDocument, setSituationDocument] = useState("");
  const [inputSituationDocument, setInputSituationDocument] = useState("");
  const [status, setStatus] = useState("");
  const [inputStatus, setInputStatus] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const { uuid } = useParams();

  let tag = localStorage.getItem("Tag");

  const step = window.location.search;

  const navigate = useNavigate();

  const optionsSituationDocument = ["Liberada", "Restrita"];

  const { user } = useAuthContext();

  let optionsStatus = [];

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true);

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          switch (response.data.situation_document) {
            case 1:
              setSituationDocument("Liberada");
              break;
            case 5:
              setSituationDocument("Restrita");
              break;
            default:
              break;
          }

          switch (response.data.reason_reprovation) {
            case "1":
              setReason("Inconsistência de dados");
              break;
            case "2":
              setReason("Prazo de envio de documentos excedido");
              break;
            case "3":
              setReason("Já é cooperado");
              break;
            default:
              break;
          }

          switch (response.data.status) {
            case 1:
              setStatus("Em aberto");
              break;
            case 2:
              setStatus("Iniciado");
              break;
            case 3:
              setStatus("Em análise");
              break;
            case 4:
              setStatus("Documentos pendentes");
              break;
            case 5:
              setStatus("Em processo admissão");
              break;
            case 6:
              setStatus("Aprovado");
              break;
            case 7:
              setStatus("Reprovado");
              break;
            case 8:
              setStatus("Aguardando Assinatura");
              break;
            case 9:
              setStatus("Pendente Envio Empresa");
              break;
            case 10:
              setStatus("Finalização Cadastral");
              break;
            default:
              break;
          }
          setCooperated(response.data);

          const pasArray = await axios.get(URL_API + `/pas?page=1&limit=500`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.data.pa_id) {
            const value = pasArray.data.data.find(
              (pa) => pa.uuid === response.data.pa_id
            );

            setPa(value);
          }

          setPas(pasArray.data.data);

          setLoading(false);
        }
      } catch (e) {
        toast.error(e.response);
      }
    })();
    // eslint-disable-next-line
  }, [uuid]);

  const situationDocumentToNumber = (doc) => {
    switch (doc) {
      case "Liberada":
        return 1;
      case "Restrita":
      default:
        return 5;
    }
  };

  const statusToNumber = (stts) => {
    switch (stts) {
      case "Em aberto":
        return 1;
      case "Iniciado":
        return 2;
      case "Em análise":
        return 3;
      case "Documentos pendentes":
        return 4;
      case "Em processo admissão":
        return 5;
      case "Aprovado":
        return 6;
      case "Reprovado":
        return 7;
      case "Aguardando Assinatura":
        return 8;
      case "Pendente Envio Empresa":
        return 9;
      case "Finalização Cadastral":
        return 10;
      default:
        return 1;
    }
  };

  const handleNext = async () => {
    try {
      const data = {
        ...cooperated,
        pa_id: pa.uuid,
        situation_document: situationDocumentToNumber(situationDocument),
        reason_reprovation: reasonToNumber(reason),
        status: statusToNumber(status),
        step: 7,
      };

      if (!data.pa_id) return toast.warn("Selecione o PA");

      if (uuid) {
        const response = await axios.put(
          `${URL_API}/cooperated/${uuid}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          }
        );

        if (response.status === 200) {
          if (user.profile !== 99) {
            navigate(`/admin/colaboradores`);
          } else {
            navigate(`/admin/colaboradores/atualizar/${uuid}?step=7`);
          }
        }
      } else {
        const response = await axios.post(`${URL_API}/cooperated`, data, {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        });

        if (response.status === 200) {
          if (user.profile !== 99) {
            navigate(`/admin/colaboradores`);
          } else {
            navigate(
              `/admin/colaboradores/atualizar/${response.data.uuid}?step=7`
            );
          }
        }
      }
    } catch (e) {
      toast.error(e.response.data);
    }
  };

  const setInput = (event) => {
    const { name, value } = event.target;

    const newCooperated = {
      ...cooperated,
      [name]: value,
    };

    setCooperated(newCooperated);
  };

  if (!status || status === 1) {
    optionsStatus = [
      "Em aberto",
      "Iniciado",
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
      "Pendente Envio Empresa",
    ];
  } else if (status === 2) {
    optionsStatus = [
      "Iniciado",
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
      "Pendente Envio Empresa",
    ];
  } else {
    optionsStatus = [
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
      "Pendente Envio Empresa",
    ];
  }

  const optionsReason = [
    "Inconsistência de dados",
    "Prazo de envio de documentos excedido",
    "Já é cooperado",
  ];

  const reasons = (res) => {
    switch (res) {
      case 1:
        return "Inconsistência de dados";
      case 2:
        return "Prazo de envio de documentos excedido";
      case 3:
        return "Já é cooperado";
      default:
        return res;
    }
  };

  const reasonToNumber = (res) => {
    switch (res) {
      case "Inconsistência de dados":
        return 1;
      case "Prazo de envio de documentos excedido":
        return 2;
      case "Já é cooperado":
        return 3;
      default:
        return res;
    }
  };

  const PA = (pa) => pas.filter((obj) => obj.uuid === pa)[0];

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Descrição</MDTypography>
        <MDTypography variant="button" color="text"></MDTypography>
      </MDBox>

      {loading ? (
        <Box sx={{ width: "100%" }}>
          <LinearProgress sx={{ overflow: "hidden" }} />
        </Box>
      ) : (
        <>
          <MDBox mt={1.625}>
            <Autocomplete
              value={pa ?? PA(pa) ?? ""}
              onChange={(_, newValue) => {
                setPa(newValue);
              }}
              inputValue={inputPa}
              onInputChange={(_, newInputValue) => {
                setInputPa(newInputValue);
              }}
              getOptionLabel={(pa) => (pa ? `${pa.number} - ${pa.name}` : "")}
              options={pas}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Selecione o P.A."
                  required
                />
              )}
            />

            {user?.profile === 1 && user?.company_id && (
              <FormField
                type="text"
                label="Descrição Privada"
                name="private_description"
                value={cooperated.private_description}
                multiline
                rows={5}
                placeholder="Descrição Privada"
                onChange={setInput}
              />
            )}

            {user?.profile === 99 && (
              <>
                <Autocomplete
                  value={situationDocument}
                  onChange={(_, newValue) => {
                    setSituationDocument(newValue);
                  }}
                  inputValue={inputSituationDocument}
                  onInputChange={(_, newInputValue) => {
                    setInputSituationDocument(newInputValue);
                  }}
                  options={optionsSituationDocument}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Situação CPF"
                    />
                  )}
                />

                <Autocomplete
                  value={status}
                  onChange={(_, newValue) => {
                    setStatus(newValue);
                  }}
                  inputValue={inputStatus}
                  onInputChange={(_, newInputValue) => {
                    setInputStatus(newInputValue);
                  }}
                  options={optionsStatus}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Status da conta"
                    />
                  )}
                />
                {status === "Reprovado" && (
                  <Autocomplete
                    value={reason ?? reasons(reason)}
                    onChange={(_, newValue) => {
                      setReason(newValue);
                    }}
                    inputValue={reason}
                    onInputChange={(_, newInputValue) => {
                      setReason(newInputValue);
                    }}
                    options={optionsReason}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Motivo da reprovação"
                      />
                    )}
                  />
                )}

                {status === "Reprovado" && reason === "Já é cooperado" && (
                  <FormField
                    type="text"
                    label="Número da conta"
                    name="account_number"
                    value={cooperated.account_number}
                    placeholder="Número da conta"
                    onChange={setInput}
                  />
                )}
                {status === "Aprovado" && (
                  <FormField
                    type="text"
                    label="Número da conta"
                    name="account_number"
                    value={cooperated.account_number}
                    placeholder="Número da conta"
                    onChange={setInput}
                  />
                )}
              </>
            )}
          </MDBox>

          <MDBox
            mt={2}
            width="100%"
            display="flex"
            justifyContent="space-between"
          >
            <MDButton
              variant="gradient"
              color="light"
              onClick={() => {
                if (user?.profile !== 99) {
                  navigate(`/admin/colaboradores/atualizar/${uuid}?step=6`);
                } else {
                  navigate(`/admin/colaboradores/atualizar/${uuid}?step=5`);
                }
              }}
            >
              voltar
            </MDButton>

            {step === "?step=7" && user?.profile !== 99 ? (
              <MDBox
                mt={2}
                width="30%"
                display="flex"
                justifyContent="space-evenly"
              >
                <Tooltip title="Volta para a listagem de Colaboradores, sem salvar alterações">
                  <MDButton
                    variant="gradient"
                    color="secondary"
                    onClick={() => navigate("/admin/colaboradores")}
                  >
                    fechar
                  </MDButton>
                </Tooltip>
                <Tooltip title="Salva os dados do formulário e volta para a listagem">
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="dark"
                    onClick={handleNext}
                  >
                    fechar e salvar
                  </MDButton>
                </Tooltip>
              </MDBox>
            ) : (
              <MDButton
                type="submit"
                variant="gradient"
                color="dark"
                onClick={handleNext}
              >
                {user?.profile !== 99 ? "salvar" : "próximo"}
              </MDButton>
            )}
          </MDBox>
        </>
      )}
    </MDBox>
  );
}
